import React, { ReactElement } from 'react'
import "./index.less"
export default function Loading(props) {
  
  return (
    <div className='loading'>

    </div>
  )
} 